// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ShippingWeight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.7 0c1.363 0 2.468.994 2.66 2.3h8.24c.3 0 .6.3.6.6v9c0 .3-.3.6-.6.6h-9c-.3 0-.6-.3-.6-.6V5.057a2.686 2.686 0 0 1-1 .313v8.03h12.7c.2 0 .3.1.3.3 0 .2-.1.3-.3.3H1c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3h1.4V5.37A2.678 2.678 0 0 1 0 2.7C0 1.2 1.2 0 2.7 0Zm5.248 3H5.37a2.67 2.67 0 0 1-.67 1.506V11.7h8.8V3h-3.303v1.2a.374.374 0 0 1-.564.324l-.561-.325-.561.325a.372.372 0 0 1-.375.001.375.375 0 0 1-.188-.325V3Zm2.24 5.975a.375.375 0 0 1 0 .75H7.956a.375.375 0 0 1 0-.75ZM9.072 5.34c.104 0 .197.042.265.11l1.109 1.108a.377.377 0 0 1-.265.641.376.376 0 0 1-.266-.11l-.468-.468v1.657a.375.375 0 0 1-.75 0V6.62l-.468.47a.375.375 0 0 1-.53-.532L8.807 5.45a.374.374 0 0 1 .265-.11ZM2.7.7C1.6.7.6 1.7.6 2.8s.9 2 2.1 2c1.2 0 2.1-.8 2.1-2S3.8.7 2.7.7ZM9.447 3h-.749v.549l.185-.108a.379.379 0 0 1 .377 0l.187.108V3ZM2.7 1.6a.3.3 0 0 1 .3.3v.41a.492.492 0 0 1-.3.89.492.492 0 0 1-.3-.89V1.9a.3.3 0 0 1 .3-.3Z"
            />
        </svg>
    );
};

export default React.memo(ShippingWeight);
